import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/api/client";
import ProductCard from "@/components/ProductCard";

export default function DropPage() {
  const { id } = useParams();
  const [drop, setDrop] = useState(null);
  const [sortBy, setSortBy] = useState("theme");
  useEffect(() => { api.get(`/drops/${id}`).then((r) => setDrop(r.data)).catch(() => setDrop(null)); }, [id]);
  if (!drop) return <div className="p-10 text-center text-gray-500">Loading drop…</div>;
  const products = [...(drop.products || [])];
  if (sortBy === "price-low") products.sort((a, b) => (a.drop_price ?? 0) - (b.drop_price ?? 0));
  if (sortBy === "price-high") products.sort((a, b) => (b.drop_price ?? 0) - (a.drop_price ?? 0));
  return (
    <div className="mx-auto max-w-7xl px-4 lg:px-8 py-10" data-testid="drop-page">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#F48E2E] font-bold mb-2">CityShor Drop · {drop.state}</div>
        <h1 className="font-display text-4xl md:text-5xl mb-1">{drop.name}</h1>
        {drop.theme && <div className="text-sm text-gray-600">Theme · {drop.theme}</div>}
        {drop.tagline && <p className="text-gray-700 mt-2 max-w-2xl">{drop.tagline}</p>}
      </div>
      <div className="flex items-center justify-between mb-4">
        <div className="text-sm text-gray-500">{products.length} products</div>
        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="h-9 rounded-full border border-gray-300 px-3 text-sm bg-white" data-testid="drop-sort">
          <option value="theme">Sort by theme</option>
          <option value="price-low">Price · low to high</option>
          <option value="price-high">Price · high to low</option>
        </select>
      </div>
      {products.length === 0 ? (
        <div className="text-center py-20 text-gray-500">No products in this drop yet.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {products.map((p) => (
            <div key={p.submission_id} className="relative" data-testid={`drop-product-${p.id}`}>
              <ProductCard product={p} />
              <div className="absolute top-3 right-3 flex flex-col items-end gap-1 pointer-events-none">
                <span className="px-2 py-1 rounded-full bg-[#111827] text-white text-[10px] font-bold uppercase tracking-wider">Drop price</span>
                {p.drop_original_price > p.drop_price && (
                  <span className="text-[10px] text-white bg-black/60 px-2 py-1 rounded-full line-through">₹{Number(p.drop_original_price).toLocaleString("en-IN")}</span>
                )}
              </div>
              <div className="mt-2 flex flex-wrap gap-2 text-[11px]">
                <span className={`px-2 py-1 rounded-full font-medium ${p.sold_out ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-800"}`}>
                  {p.sold_out ? "Sold Out" : `${p.drop_qty_remaining} left`}
                </span>
                {!p.sold_out && <span className="px-2 py-1 rounded-full bg-gray-100 text-gray-600">{p.viewing_now} people viewing</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
